import { render, staticRenderFns } from "./UiConfEditor.vue?vue&type=template&id=402965af&scoped=true&"
import script from "./UiConfEditor.vue?vue&type=script&lang=js&"
export * from "./UiConfEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402965af",
  null
  
)

export default component.exports